// The tree's share card, for both apps: its size, where the scene sits, and
// its words. Each app draws it its own way (the web as SVG, native as views).
import type { TreeState } from "@aybuben/core/progress/tree.ts";

import type { UiKey } from "../i18n/en.ts";
import { STAGE_KEY } from "./labels.ts";
import { STAGE_HY } from "./stage-names.ts";

type Translate = (key: UiKey, params?: Record<string, string | number>) => string;

export interface ShareText {
	/** The tree's name, or the default title. */
	title: string;
	/** The stage in the learner's language, then in Armenian. */
	stage: string;
	hy: string;
	/** A line of numbers under the stage. */
	caption: string;
	/** The message that goes with the picture. */
	text: string;
}

export const CARD_W = 1080;
export const CARD_H = 1350;
export const SITE = "aybuben.santiago.gd";
/** The scene's rounded square, in card pixels; the tree stands in it with the scene's insets (2% above, 10% below). */
export const SCENE = { x: 90, y: 200, size: 900, radius: 64 } as const;

export function shareText({
	name,
	tree,
	t,
}: {
	name: string;
	tree: TreeState;
	t: Translate;
}): ShareText {
	return {
		title: name || t("tree.title"),
		stage: t(STAGE_KEY[tree.stage]),
		hy: STAGE_HY[tree.stage],
		caption: t("tree.shareCaption", { harvest: tree.harvest, ribbons: tree.ribbons.length }),
		text: t("tree.shareText"),
	};
}
